function getUserInfo() {
  const state = localStorage.getItem('userInfo');
  const userInfo = state && JSON.parse(state);
  return userInfo || {};
}
declare global {
  interface Window {
    arms: any; // 这里使用 any 类型，如果有具体类型可以替换
    __rum: any;
    RumSDK: any;
  }
}
window.arms = null;
window.__rum = {};

if (['prod'].includes(import.meta.env.VITE_ARMS_ENV)) {
  const pid = 'ifau0s9vzy@102ffa1541992fa';
  const endpoint = 'https://ifau0s9vzy-default-cn.rum.aliyuncs.com';

  const script = document.createElement('script');
  // script.src = '/browser-sdk.js'
  script.src = 'https://ifau0s9vzy-sdk.rum.aliyuncs.com/v2/browser-sdk.js';
  script.setAttribute('crossOrigin', '');

  // 检查 head 元素是否存在
  const headElement = document.head || document.querySelectorAll('head')[0];
  if (headElement) {
    headElement.append(script);
  } else {
    console.error('无法找到 head 元素，无法插入脚本');
  }

  window.__rum = window.__rum || {};

  const config = {
    pid,
    endpoint,
    env: import.meta.env.VITE_ARMS_ENV,
    enableSPA: true,
    // tracing:true,
    user: {
      id: getUserInfo().id,
      name: `${getUserInfo().id}-${getUserInfo().name}`,
      uid: getUserInfo().id,
    },
    uid: getUserInfo().id || 'void 0',
  };
  window.__rum = config;

  script.addEventListener('load', () => {
    const ArmsRum = window.RumSDK.default;
    window.arms = ArmsRum;
  });
}
